import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAccusoftComponent } from './simple-icons-accusoft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAccusoftComponent ],
    exports:      [ SimpleIconsAccusoftComponent ],
    bootstrap:    []
})
export class SimpleIconsAccusoftModule {}
